var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as StackTrace from 'stacktrace-js';
import { fetchJson } from '../fetch/fetchJson';
var defaultErrorOptions = {
    logLevel: 'ERROR',
};
/**
 * Send error to backend for logging on url
 *
 * Usage:
 * For catching unhandled exceptions:
 *
 * ```
 * window.onerror = (event: Event | string, source?: string, fileno?: number, columnNumber?: number, error?: Error) => {
 *   remoteLogError(`/gpf-tjenestepensjon/api/remote-logging`, error);
 * };
 *
 * ```
 *
 * @param url URL for the endpoint receiving
 * @param error JS Error
 * @param errorOptions
 */
export function remoteLogError(url, error, errorOptions) {
    if (errorOptions === void 0) { errorOptions = defaultErrorOptions; }
    return __awaiter(this, void 0, void 0, function () {
        var stacktrace_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!error) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, StackTrace.fromError(error)];
                case 2:
                    stacktrace_1 = _a.sent();
                    if (!blackListedFilenames.every(function (blacklist) { return isNotBlacklisted(stacktrace_1[0], blacklist); })) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchJson(url, 'POST', {
                            message: error.message.replace(/\s/g, '_'),
                            stackTrace: stacktrace_1,
                            errorOptions: errorOptions,
                        })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function isNotBlacklisted(stackFrame, blacklist) {
    if (stackFrame.fileName && stackFrame.fileName.indexOf(blacklist) > 0) {
        return false;
    }
    if (stackFrame.source && stackFrame.source.indexOf(blacklist) > 0) {
        return false;
    }
    return true;
}
/**
 * Send a message to backend for logging.
 * @example
 * remoteLogMessage('/gpf-tjenestepensjon/api/remote-logging', 'Dette er ikke så viktig', {logLevel: 'INFO'});
 *
 * @param url
 * @param message
 * @param errorOptions
 */
export function remoteLogMessage(url, message, errorOptions) {
    if (errorOptions === void 0) { errorOptions = defaultErrorOptions; }
    return __awaiter(this, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchJson(url, 'POST', {
                            message: message.replace(/\s/g, '_'),
                            errorOptions: errorOptions,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
var blackListedFilenames = [
    'wds.callguide.telia.com/wds/instances/',
    'www.gjensidige.no/_public/gjensidigewww/lib/requirejs/',
    'www.gjensidige.no/_public/gjensidigewww/scripts/footer-min.js',
    'www.gjensidige.no/_public/shared/application/callguide/mcc-chat.js',
    'www.gjensidige.no/no/2/Din+side/_public/shared/scripts/system-messages.js',
    'www.gjensidige.no/_public/gjensidigewww/scripts/head-min.js',
];
